var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsEnum, IsNumber, IsOptional, ValidateNested } from "class-validator";
import { ConsentFlowProgressDto } from "./consent.dtos";
import { StudyDto, StudyParticipationType } from "./study.dtos";
export class StudyWithIncludesDto extends StudyDto {
}
__decorate([
    ApiPropertyOptional({
        isArray: true,
        type: () => ConsentFlowProgressDto,
    }),
    Type(() => ConsentFlowProgressDto),
    ValidateNested({ each: true }),
    IsOptional()
], StudyWithIncludesDto.prototype, "consentFlowProgress", void 0);
export class StudySearchDto extends StudyWithIncludesDto {
}
__decorate([
    ApiPropertyOptional({
        enumName: "StudyParticipationType",
    }),
    IsEnum(StudyParticipationType),
    IsOptional()
], StudySearchDto.prototype, "participationType", void 0);
export class StudySearchResult {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty(),
    IsNumber()
], StudySearchResult.prototype, "total", void 0);
__decorate([
    ApiProperty({
        isArray: true,
        type: StudySearchDto,
    }),
    Type(() => StudySearchDto),
    ValidateNested({ each: true })
], StudySearchResult.prototype, "results", void 0);
